var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92085 3.67085C9.14866 3.44305 9.51801 3.44305 9.74581 3.67085L12.6625 6.58752C12.8903 6.81533 12.8903 7.18467 12.6625 7.41248L9.74581 10.3291C9.51801 10.557 9.14866 10.557 8.92085 10.3291C8.69305 10.1013 8.69305 9.73199 8.92085 9.50419L11.425 7L8.92085 4.49581C8.69305 4.26801 8.69305 3.89866 8.92085 3.67085Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66699 7.00033C4.66699 6.67816 4.92816 6.41699 5.25033 6.41699H12.2503C12.5725 6.41699 12.8337 6.67816 12.8337 7.00033C12.8337 7.32249 12.5725 7.58366 12.2503 7.58366H5.25033C4.92816 7.58366 4.66699 7.32249 4.66699 7.00033Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91699 2.33366C2.76228 2.33366 2.61391 2.39512 2.50451 2.50451C2.39512 2.61391 2.33366 2.76228 2.33366 2.91699V11.0837C2.33366 11.2384 2.39512 11.3867 2.50451 11.4961C2.61391 11.6055 2.76228 11.667 2.91699 11.667H5.25033C5.57249 11.667 5.83366 11.9282 5.83366 12.2503C5.83366 12.5725 5.57249 12.8337 5.25033 12.8337H2.91699C2.45286 12.8337 2.00774 12.6493 1.67956 12.3211C1.35137 11.9929 1.16699 11.5478 1.16699 11.0837V2.91699C1.16699 2.45286 1.35137 2.00774 1.67956 1.67956C2.00774 1.35137 2.45286 1.16699 2.91699 1.16699H5.25033C5.57249 1.16699 5.83366 1.42816 5.83366 1.75033C5.83366 2.07249 5.57249 2.33366 5.25033 2.33366H2.91699Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.6cff4e9f5bf9f896863a60f75c084115.svg";
export { ForwardRef as ReactComponent };